export const MAX_CARD_CNT = 50;

// 모달 관련 상수
export const MODAL_WIDTH = 1722; // px